<div class="form-field__label">
  <ng-content select="label"></ng-content>
</div>
<div class="form-field__control">
  <ng-content></ng-content>
</div>
<span class="form-field__error" *ngIf="showError && errorMessage" role="alert" aria-live="polite">
  {{ errorMessage }}
</span>
